// import Vue from 'vue'
import Req from './request.js';

export default{
	
	//路由参数截取
	getQueryString(name){
		var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i');
		if (reg.test(location.href)) return unescape(RegExp.$2.replace(/\+/g, ' '));
		return null;
	},

	checkLogin() {
		if (!localStorage['login'] || localStorage['login'] == null) {
			return false;
		} else {
			return true;
		}
	},
	getQueryVariable(variable){
		// var query = window.location.search.substring(1);
		var query = window.location.hash.split("?")[1]
		var vars = query.split("&");
		for (var i=0;i<vars.length;i++) {
				var pair = vars[i].split("=");
				if(pair[0] == variable){return pair[1];}
		}
	},
	// 埋点接口 方法
	Burying(data){
		/* 参数解释
		 @topic  埋点来源  cloudpc-web
		 @act 对应埋点业务的唯一标识   string类型
		 @other  其他参数 对象埋点类型需要的参数
		 */
		// console.log(location.origin)
		// if(document.domain.indexOf('cloudpc.cn')==-1)return;
		if(location.origin!='https://www.cloudpc.cn'&&
        location.origin!='https://cloudpc.cn'&&
        location.origin!='http://www.cloudpc.cn'&&
        location.origin!='http://cloudpc.cn')return;
		let url = 'https://log-cloudpc.cloudpc.cn/v1/invoke';
		// if(this.getQueryVariable("channel")){
		// 	if(this.getQueryVariable("channel")==0){
		// 		data.Channel_source="web"
		// 	}else if(parseFloat(this.getQueryVariable("channel")).toString()=="NaN"){
		// 		data.Channel_source=this.getQueryVariable("channel")
		// 	}else{
		// 		data.Channel_source="gamemanager"+this.getQueryVariable("channel")
		// 	}
		// }else{
		// 	data.Channel_source="web"
		// }
		data.Channel_source=sessionStorage['channel']||'web'
		data['topic'] = 'cloudpc-web';	
		Req.post(url,data)
		.then(()=>{
			// console.log(res)
		})
	},
	
	// 浏览器检测
	checkBrowser(){
		var sBrowser, sUsrAg = navigator.userAgent;
		sUsrAg = sUsrAg.toLowerCase();
		var BrowserName = '';
		// The order matters here, and this may report false positives for unlisted browsers.
		
		if (sUsrAg.indexOf("firefox") > -1) {
			sBrowser = "Mozilla Firefox";
			BrowserName = 'Firefox';
			// "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
		} else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
			sBrowser = "Opera";
			BrowserName = 'Opera';
			//"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
		} else if (sUsrAg.indexOf("trident") > -1||sUsrAg.indexOf("msie") > -1) {
			sBrowser = "Microsoft Internet Explorer";
			BrowserName = 'IE';
			// "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
		} else if (sUsrAg.indexOf("edge") > -1) {
			sBrowser = "Microsoft Edge";
			BrowserName = 'Edge';
			// "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
		} else if (sUsrAg.indexOf("chrome") > -1) {
			sBrowser = "Google Chrome or Chromium";
			BrowserName = 'Chrome';
			// "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
		} else if (sUsrAg.indexOf("safari") > -1) {
			sBrowser = "Apple Safari";
			BrowserName = 'Safari';
			// "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
		} else if(sUsrAg.indexOf('maxthon') > -1){
			sBrowser = "傲游浏览器";
			BrowserName = '傲游浏览器';
		} else if(sUsrAg.indexOf('qqbrowser') > -1){
			sBrowser = "QQ浏览器";
			BrowserName = 'QQ浏览器';
		} else if(sUsrAg.indexOf('se 2.x') > -1){
			sBrowser = "搜狗浏览器";
			BrowserName = '搜狗浏览器';
		}else {
			sBrowser = "unknown";
			BrowserName = '未知浏览器';
		}
		console.log(sBrowser)
		window._BrowserName = BrowserName;
		setTimeout(()=>{
			this.Burying({act:'userBrowserName',BrowserName:window._BrowserName,operating_system:'web'});
		},2000)
		
		// if(sBrowser == 'Microsoft Internet Explorer'||sBrowser == 'Microsoft Edge'){
		// 	// alert('检测到您使用的不是谷歌浏览器,使用谷歌浏览器才能进行云游戏!');
		// 	location.replace('indexForIE.html')
			
			
		// }
		// if(sBrowser !== 'Google Chrome or Chromium'){
		// 	// alert('检测到您使用的不是谷歌浏览器,使用谷歌浏览器才能进行云游戏!');
		// 	if(top._vue){
		// 		top._vue.browserDialogShow = true;
		// 		top._vue.NoviceGiftShow = false;
		// 	}else{
		// 		window._vue.browserDialogShow = true;
		// 		window._vue.NoviceGiftShow = false;
		// 	}
			
		// }
	}
}